export const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

const compactCurrencyFormatter = new Intl.NumberFormat('nl-BE', {
  style: 'currency',
  currency: 'EUR',
  notation: 'compact',
  maximumFractionDigits: 1
});

export function formatCompactCurrency(value) {
  return compactCurrencyFormatter.format(toNumber(value));
}

const percentFormatter = new Intl.NumberFormat('nl-BE', { style: 'percent', maximumFractionDigits: 1 });

export function formatPercent(value) {
  if (!Number.isFinite(value)) return '—';
  return percentFormatter.format(value);
}

const integerFormatter = new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 0 });

export function formatInteger(value) {
  return integerFormatter.format(toNumber(value));
}

const dayFormatter = new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 1 });

export function formatDays(value) {
  if (!Number.isFinite(Number(value))) return '—';
  return `${dayFormatter.format(Number(value))} d`;
}

// Relative difference between two values; null when there is no usable base value
export function deltaPercent(current, previous) {
  const cur = toNumber(current);
  const prev = Number(previous);
  if (!Number.isFinite(prev) || Math.abs(prev) < 0.01) return null;
  return (cur - prev) / Math.abs(prev);
}

export function getYears(rows, yearKey = 'year') {
  const years = [...new Set((rows || []).map((row) => Number(row[yearKey])).filter((year) => Number.isFinite(year)))];
  return years.sort((a, b) => a - b);
}

export function sumBy(rows, key) {
  return (rows || []).reduce((total, row) => total + toNumber(row[key]), 0);
}

export function formatShortDate(value) {
  if (!value) return '';
  return String(value).substring(0, 10);
}

// Query string for the period-detail endpoints from a drill period object
export function periodToQueryParams(period) {
  const params = new URLSearchParams({ year: period.year });
  if (period.month) params.append('month', period.month);
  else if (period.quarter) params.append('quarter', period.quarter);
  else if (period.half) params.append('half', period.half);
  else if (period.through_month) params.append('through_month', period.through_month);
  return params;
}

// Background color for heatmap cells: intensity relative to the matrix maximum
export function heatColor(value, max, rgb = '46, 125, 50') {
  const numeric = toNumber(value);
  if (numeric <= 0 || !Number.isFinite(max) || max <= 0) return 'transparent';
  const alpha = Math.min(0.85, Math.max(0.06, (numeric / max) * 0.85));
  return `rgba(${rgb}, ${alpha})`;
}
